module.exports = {
  user_info: {
    default_type: 10, // 记录类型
    field: 'realname' // 用户的field字段信息
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/userInfo.js